// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-c09badca] .upload-form {\n  margin-top: 5vh !important;\n}\n[data-v-c09badca] .upload-form .el-dialog__body {\n  max-height: 100vh !important;\n}\n.form-input[data-v-c09badca] {\n  width: 300px;\n}", ""]);
// Exports
module.exports = exports;
